var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterController(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08001 7.04004H1.26001",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7381 7.04004H10.0061",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.994 17.0938H1.26099",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7379 17.0938H18.9199",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08008 6.89952C5.08008 7.22297 5.14379 7.54325 5.26756 7.84207C5.39134 8.1409 5.57276 8.41242 5.80147 8.64113C6.03018 8.86984 6.3017 9.05126 6.60053 9.17504C6.89935 9.29882 7.21963 9.36252 7.54308 9.36252C7.86652 9.36252 8.1868 9.29882 8.48563 9.17504C8.78445 9.05126 9.05597 8.86984 9.28468 8.64113C9.51339 8.41242 9.69482 8.1409 9.81859 7.84207C9.94237 7.54325 10.0061 7.22297 10.0061 6.89952C10.0061 6.57608 9.94237 6.2558 9.81859 5.95697C9.69482 5.65815 9.51339 5.38663 9.28468 5.15792C9.05597 4.92921 8.78445 4.74779 8.48563 4.62401C8.1868 4.50023 7.86652 4.43652 7.54308 4.43652C7.21963 4.43652 6.89935 4.50023 6.60053 4.62401C6.3017 4.74779 6.03018 4.92921 5.80147 5.15792C5.57276 5.38663 5.39134 5.65815 5.26756 5.95697C5.14379 6.2558 5.08008 6.57608 5.08008 6.89952Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9939 17.0958C13.9939 17.749 14.2534 18.3755 14.7153 18.8374C15.1772 19.2993 15.8037 19.5588 16.4569 19.5588C17.1101 19.5588 17.7366 19.2993 18.1985 18.8374C18.6604 18.3755 18.9199 17.749 18.9199 17.0958C18.9199 16.4426 18.6604 15.8161 18.1985 15.3542C17.7366 14.8923 17.1101 14.6328 16.4569 14.6328C15.8037 14.6328 15.1772 14.8923 14.7153 15.3542C14.2534 15.8161 13.9939 16.4426 13.9939 17.0958Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterController);
export default __webpack_public_path__ + "static/media/filter-controller.c9c83b19a0281e96c9c3b4bc91649ae3.svg";
export { ForwardRef as ReactComponent };